import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = ["content"];

  //読み込み時
  initialize() {
    this.contentTargets.forEach((element) => {
      var trigger = $(element);
      this.showToggleButton(trigger);
    });
  }

  //トグルの中にある時の処理
  toggleClick() {
    this.contentTargets.forEach((element) => {
      var trigger = $(element);
      this.showToggleButton(trigger);
    });
  }

  //コンテンツの長さがmax-heightに満たない時「続きを見る」ボタンは非表示
  showToggleButton(trigger) {
    var scrollHeight = trigger[0].scrollHeight;
    var toggle = trigger.closest(".js-toggle-more");
    var button = toggle.find(".js-toggle-more-button");

    // SP時のイベント詳細のみ取得するmaxHeightの値変更
    var hasDetailPage = trigger.data("page") === "event-detail";
    var isSmallScreen = window.innerWidth <= 767;
    // ビューポートの高さを取得
    var windowHeight = $(window).height();
    var viewportHeight = windowHeight * 0.4; // cssで指定しているvhの値を計算

    var maxHeight;
    if (hasDetailPage && isSmallScreen) {
      maxHeight = Math.round(viewportHeight);
    } else {
      maxHeight = trigger.css("--max-height");
    }

    if (scrollHeight <= maxHeight) {
      button.hide();
      // aria属性
      $(this).attr("aria-expanded", true);
      trigger.attr("aria-hidden", false);
    } else {
      button.show().css("opacity", "1");
      // aria属性
      if (trigger.hasClass("is-open")) {
        trigger.attr("aria-hidden", false);
      } else {
        trigger.attr("aria-hidden", true);
      }
    }
  }

  //「続きを見る」ボタンクリック時
  seeNext(e) {
    var toggle = $(e.currentTarget).closest(".js-toggle-more");
    var content = toggle.find(".js-toggle-more-content");
    $(e.currentTarget).toggleClass("is-open");
    content.toggleClass("is-open");
    if (content.hasClass("is-open")) {
      var h = content.get(0).scrollHeight;
      content.css("max-height", h);
      // aria属性
      $(e.currentTarget).attr("aria-expanded", true);
      content.attr("aria-hidden", false);
    } else {
      content.css("max-height", "");
      // aria属性
      $(e.currentTarget).attr("aria-expanded", false);
      content.attr("aria-hidden", true);
    }
  }

  //リサイズ時
  resize() {
    this.contentTargets.forEach((element) => {
      var content = $(element);

      //リサイズ完了後
      setTimeout(() => {
        var h = content.get(0).scrollHeight;

        if (content.hasClass("is-open")) {
          content.css("max-height", h);
        }

        this.showToggleButton(content);
      }, 300);
    });
  }
}
